var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleMicrosoftexcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.343,
    viewBox: "0 0 36 35.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-microsoftexcel",
    "data-name": "Icon simple-microsoftexcel",
    d: "M35.329,4.653H23.269V6.885h3.555v3.531H23.269v1.125h3.555v3.535H23.269v1.156h3.555v3.344H23.269v1.34h3.555v3.351H23.269v1.34h3.555v3.371H23.269v2.458h12.06c.19-.057.349-.282.477-.672A3.289,3.289,0,0,0,36,29.809V5.061c0-.192-.066-.307-.194-.348A1.65,1.65,0,0,0,35.329,4.653ZM33.765,28.974H27.979V25.607h5.785v3.368Zm0-4.707H27.979V20.915h5.785Zm0-4.692H27.979V16.247h5.785v3.329Zm0-4.5H27.979V11.544h5.785v3.531Zm0-4.679H27.979V6.887h5.785V10.4ZM0,4.1V32l21.24,3.674V.329L0,4.109ZM12.59,25.2q-.122-.328-1.137-2.795c-.674-1.644-1.08-2.6-1.2-2.874h-.038L7.938,24.957l-3.045-.205L8.505,18,5.2,11.252l3.1-.163,2.052,5.281h.04l2.318-5.521,3.208-.2-3.82,7.3L16.038,25.4l-3.448-.2Z",
    transform: "translate(0 -0.328)",
    fill: "#397a42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleMicrosoftexcel);
export default __webpack_public_path__ + "static/media/simple-microsoftexcel.b5ba81306a3d6964dc6513e120a4a158.svg";
export { ForwardRef as ReactComponent };